import _ from 'underscore';

app.CampusCardTenderView = app.AccordionFieldView.extend({
  className() {
    return `${app.AccordionFieldView.prototype.className.apply(this)} virtual-sub-group-panel`;
  },

  initialize(options) {
    const baseOptions = options || {};
    const mergedOptions = _.extend({}, options || {}, {
      newValue() {
        return _.mapObject(mergedOptions.schema.fields, (fieldSchema) => {
          if (fieldSchema.defaultValue !== undefined) {
            return fieldSchema.defaultValue;
          }

          switch (fieldSchema.type) {
            case 'int':
            case 'float':
            case 'price':
              return null;
            default:
              return '';
          }
        });
      },
      getTitle(fieldGroupView) {
        const fields = fieldGroupView.getValue();
        if (!fields) {
          return '';
        }
        const tenderNumber = fields.tenderNumber;
        const displayName = fields.displayName;
        if (tenderNumber && displayName) {
          return `Tender ${tenderNumber} — ${displayName}`;
        }
        if (tenderNumber) {
          return `Tender ${tenderNumber}`;
        }
        if (displayName) {
          return displayName;
        }
        return '';
      },
      templateData: {
        title: baseOptions.schema.displayName || 'Campus Card Tenders',
        buttonText: 'New tender',
        emptyText: 'No tenders yet',
      },
    });

    app.AccordionFieldView.prototype.initialize.call(this, mergedOptions);
  },
});
